export const formatSpeed = (speed: string): number => {
    const numberSpeed = Math.round(parseFloat(speed.split(' ')[0]));
    if (isNaN(numberSpeed)) return 0;

    return numberSpeed;
};
